
export const crossSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 31 28"
    fill="none"
  >
    <path d="M1 1L30 27" stroke="white" strokeWidth="2" />
    <path d="M1 27L30 1" stroke="white" strokeWidth="2" />
  </svg>
);

export const data = [
  {
    title: "Home",
    link: "#home",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="28"
        viewBox="0 0 31 28"
        fill="none"
      >
        <g filter="url(#filter0_d_534_728)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.5885 3.45038C15.988 2.84987 15.0138 2.84987 14.4133 3.45038L5.18256 12.6811C4.58205 13.2816 4.58205 14.2559 5.18256 14.8564C5.78306 15.4569 6.7573 15.4569 7.3578 14.8564L7.80773 14.4064V21.4619C7.80773 22.311 8.49532 23.0004 9.34619 23.0004H21.6538C22.5047 23.0004 23.1923 22.311 23.1923 21.4619V14.4064L23.6422 14.8564C24.2427 15.4569 25.217 15.4569 25.8175 14.8564C26.418 14.2559 26.418 13.2816 25.8175 12.6811L16.5867 3.45038H16.5885Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_534_728"
            x="0.732178"
            y="0"
            width="29.5356"
            height="28.0004"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.211765 0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_534_728"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_534_728"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
  },
  {
    title: "bookNow",
    link: "#bookNow",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="29"
        viewBox="0 0 27 29"
        fill="none"
      >
        <g filter="url(#filter0_d_892_120)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.2064 7.05308H20.7936V21.6652H6.2064V7.05308ZM5.39379 5.21802H8.70815V6.15884H5.39379C5.36842 6.15884 5.34494 6.16961 5.32773 6.18687C5.31048 6.20412 5.29971 6.2276 5.29971 6.25292V22.4653C5.29971 22.4907 5.31048 22.5141 5.32773 22.5314C5.34499 22.5486 5.36847 22.5594 5.39379 22.5594H21.6062C21.6316 22.5594 21.655 22.5486 21.6723 22.5314C21.6895 22.5141 21.7003 22.4907 21.7003 22.4653V6.25292C21.7003 6.22755 21.6895 6.20412 21.6723 6.18687C21.655 6.16961 21.6316 6.15884 21.6062 6.15884H18.2918V5.21802H21.6062C21.8913 5.21802 22.1501 5.33434 22.3375 5.52163C22.5248 5.70899 22.6411 5.96781 22.6411 6.25292V22.4653C22.6411 22.7504 22.5248 23.0093 22.3375 23.1966C22.1502 23.384 21.8913 23.5002 21.6062 23.5002H5.39379C5.10868 23.5002 4.84986 23.3839 4.6625 23.1966C4.4752 23.0093 4.35889 22.7504 4.35889 22.4653V6.25292C4.35889 5.96781 4.4752 5.70899 4.6625 5.52163C4.84986 5.33434 5.10868 5.21802 5.39379 5.21802ZM16.7485 6.15884H10.2515V5.21802H16.7485V6.15884ZM17.42 3.50024H17.6203C17.8664 3.50024 18.0678 3.70161 18.0678 3.94777V6.30118C18.0678 6.54734 17.8664 6.74871 17.6203 6.74871H17.42C17.1739 6.74871 16.9725 6.54734 16.9725 6.30118V3.94777C16.9725 3.70161 17.1739 3.50024 17.42 3.50024ZM9.37971 3.50024H9.57994C9.8261 3.50024 10.0275 3.70161 10.0275 3.94777V6.30118C10.0275 6.54734 9.8261 6.74871 9.57994 6.74871H9.37971C9.13355 6.74871 8.93219 6.54734 8.93219 6.30118V3.94777C8.93219 3.70161 9.13355 3.50024 9.37971 3.50024ZM7.32716 9.25577H19.6729C19.8799 9.25577 20.0492 9.42511 20.0492 9.6321V10.1966C20.0492 10.4036 19.8799 10.5729 19.6729 10.5729H7.32716C7.12017 10.5729 6.95083 10.4036 6.95083 10.1966V9.6321C6.95083 9.42511 7.12017 9.25577 7.32716 9.25577ZM17.5666 12.5711C17.7647 12.3115 18.1359 12.2617 18.3954 12.46C18.655 12.6581 18.7048 13.0293 18.5066 13.2889L13.236 20.1868L8.54639 15.5222C8.31494 15.2921 8.31392 14.9179 8.54406 14.6864C8.77421 14.455 9.14843 14.4539 9.37988 14.6841L13.1141 18.3984L17.5666 12.5712V12.5711Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_892_120"
            x="0.358887"
            y="0.500244"
            width="26.2822"
            height="28"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.211765 0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_892_120"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_892_120"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
  },
  // {
  //   title: "language",
  //   link: "#lang",
  //   svg: {
  //     en : ( 
  //       <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
  //         <g filter="url(#filter0_d_541_1134)">
  //           <path d="M9.73828 14.0059V17H8.19141V9.21875H10.5352C11.0547 9.21875 11.5 9.27539 11.8711 9.38867C12.2422 9.49805 12.5449 9.65234 12.7793 9.85156C13.0176 10.0508 13.1914 10.2891 13.3008 10.5664C13.4102 10.8438 13.4648 11.1484 13.4648 11.4805C13.4648 11.7344 13.4297 11.9766 13.3594 12.207C13.2891 12.4336 13.1855 12.6426 13.0488 12.834C12.916 13.0215 12.752 13.1895 12.5566 13.3379C12.3613 13.4824 12.1367 13.5996 11.8828 13.6895C11.9805 13.7441 12.0723 13.8105 12.1582 13.8887C12.2441 13.9629 12.3242 14.0547 12.3984 14.1641L14.1387 17H12.75C12.5039 17 12.3145 16.8965 12.1816 16.6895L10.7637 14.2637C10.7051 14.1699 10.6387 14.1035 10.5645 14.0645C10.4941 14.0254 10.3926 14.0059 10.2598 14.0059H9.73828ZM9.73828 12.9102H10.5234C10.7734 12.9102 10.9883 12.877 11.168 12.8105C11.3516 12.7441 11.502 12.6523 11.6191 12.5352C11.7363 12.418 11.8223 12.2793 11.877 12.1191C11.9355 11.9551 11.9648 11.7773 11.9648 11.5859C11.9648 11.207 11.8477 10.916 11.6133 10.7129C11.3789 10.5059 11.0195 10.4023 10.5352 10.4023H9.73828V12.9102Z" fill="white"/>
  //           <path d="M17.9004 15.7578C18.1738 15.7578 18.416 15.7129 18.627 15.623C18.8418 15.5332 19.0215 15.4062 19.166 15.2422C19.3145 15.0781 19.4277 14.8789 19.5059 14.6445C19.584 14.4102 19.623 14.1484 19.623 13.8594V9.21875H21.1582V13.8594C21.1582 14.3281 21.082 14.7598 20.9297 15.1543C20.7812 15.5488 20.5664 15.8906 20.2852 16.1797C20.0039 16.4648 19.6621 16.6875 19.2598 16.8477C18.8574 17.0078 18.4043 17.0879 17.9004 17.0879C17.3965 17.0879 16.9414 17.0078 16.5352 16.8477C16.1328 16.6875 15.791 16.4648 15.5098 16.1797C15.2285 15.8906 15.0117 15.5488 14.8594 15.1543C14.7109 14.7598 14.6367 14.3281 14.6367 13.8594V9.21875H16.1777V13.8594C16.1777 14.1484 16.2168 14.4102 16.2949 14.6445C16.373 14.8789 16.4844 15.0781 16.6289 15.2422C16.7773 15.4062 16.957 15.5332 17.168 15.623C17.3828 15.7129 17.627 15.7578 17.9004 15.7578Z" fill="white"/>
  //           <path fill-rule="evenodd" clip-rule="evenodd" d="M22.5 4H6.5C5.94772 4 5.5 4.44772 5.5 5V21C5.5 21.5523 5.94772 22 6.5 22H22.5C23.0523 22 23.5 21.5523 23.5 21V5C23.5 4.44772 23.0523 4 22.5 4ZM6.5 3C5.39543 3 4.5 3.89543 4.5 5V21C4.5 22.1046 5.39543 23 6.5 23H22.5C23.6046 23 24.5 22.1046 24.5 21V5C24.5 3.89543 23.6046 3 22.5 3H6.5Z" fill="white"/>
  //         </g>
  //         <defs>
  //           <filter id="filter0_d_541_1134" x="0.5" y="0" width="28" height="28" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
  //           <feFlood flood-opacity="0" result="BackgroundImageFix"/>
  //           <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
  //           <feOffset dy="1"/>
  //           <feGaussianBlur stdDeviation="2"/>
  //           <feComposite in2="hardAlpha" operator="out"/>
  //           <feColorMatrix type="matrix" values="0 0 0 0 0.211765 0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0.25 0"/>
  //           <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_541_1134"/>
  //           <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_541_1134" result="shape"/>
  //           </filter>
  //         </defs>
  //       </svg>),
  //     ru : (
  //       <svg
  //         xmlns='http://www.w3.org/2000/svg'
  //         width='29'
  //         height='28'
  //         viewBox='0 0 29 28'
  //         fill='none'
  //       >
  //         <g filter='url(#filter0_d_892_205)'>
  //           <path
  //             d='M12.9375 9.21899V10.4436H9.73828V12.5002H12.2285V13.678H9.73828V15.7756H12.9434L12.9375 17.0002H8.19141V9.21899H12.9375Z'
  //             fill='white'
  //           />
  //           <path
  //             d='M14.8828 9.21899C14.9492 9.21899 15.0059 9.2229 15.0527 9.23071C15.0996 9.23462 15.1406 9.24634 15.1758 9.26587C15.2148 9.28149 15.25 9.30493 15.2812 9.33618C15.3164 9.36743 15.3555 9.40845 15.3984 9.45923L19.2305 14.51C19.207 14.2522 19.1953 14.0081 19.1953 13.7776V9.21899H20.5488V17.0002H19.7578C19.6367 17.0002 19.5352 16.9807 19.4531 16.9417C19.375 16.8987 19.2969 16.8303 19.2188 16.7366L15.3984 11.7151C15.4219 11.9573 15.4336 12.1819 15.4336 12.3889V17.0002H14.0742V9.21899H14.8828Z'
  //             fill='white'
  //           />
  //           <path
  //             fillRule='evenodd'
  //             clipRule='evenodd'
  //             d='M22.5 4.00024H6.5C5.94772 4.00024 5.5 4.44796 5.5 5.00024V21.0002C5.5 21.5525 5.94772 22.0002 6.5 22.0002H22.5C23.0523 22.0002 23.5 21.5525 23.5 21.0002V5.00024C23.5 4.44796 23.0523 4.00024 22.5 4.00024ZM6.5 3.00024C5.39543 3.00024 4.5 3.89568 4.5 5.00024V21.0002C4.5 22.1048 5.39543 23.0002 6.5 23.0002H22.5C23.6046 23.0002 24.5 22.1048 24.5 21.0002V5.00024C24.5 3.89567 23.6046 3.00024 22.5 3.00024H6.5Z'
  //             fill='white'
  //           />
  //         </g>
  //         <defs>
  //           <filter
  //             id='filter0_d_892_205'
  //             x='0.5'
  //             y='0.000244141'
  //             width='28'
  //             height='28'
  //             filterUnits='userSpaceOnUse'
  //             colorInterpolationFilters='sRGB'
  //           >
  //             <feFlood floodOpacity='0' result='BackgroundImageFix' />
  //             <feColorMatrix
  //               in='SourceAlpha'
  //               type='matrix'
  //               values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
  //               result='hardAlpha'
  //             />
  //             <feOffset dy='1' />
  //             <feGaussianBlur stdDeviation='2' />
  //             <feComposite in2='hardAlpha' operator='out' />
  //             <feColorMatrix
  //               type='matrix'
  //               values='0 0 0 0 0.211765 0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0.25 0'
  //             />
  //             <feBlend
  //               mode='normal'
  //               in2='BackgroundImageFix'
  //               result='effect1_dropShadow_892_205'
  //             />
  //             <feBlend
  //               mode='normal'
  //               in='SourceGraphic'
  //               in2='effect1_dropShadow_892_205'
  //               result='shape'
  //             />
  //           </filter>
  //         </defs>
  //       </svg>
  //   )}
  // },
  {
    title: "getGuide",
    link: "#getGuide",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="35"
        height="29"
        viewBox="0 0 35 29"
        fill="none"
      >
        <g filter="url(#filter0_d_892_122)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.26748 3.59359L16.1241 7.71238C16.5952 7.95951 16.9787 8.61595 16.9787 9.17198V22.6868C16.9787 23.2428 16.5952 23.4977 16.1241 23.2531L8.26748 19.1343C7.79639 18.8872 7.41283 18.2308 7.41283 17.6747V4.15992C7.41283 3.60131 7.79639 3.34903 8.26748 3.59359ZM9.18906 12.0654L15.0352 15.1494C15.1124 15.188 15.2102 15.1494 15.2566 15.0567C15.3029 14.9666 15.2772 14.8611 15.2025 14.8199L9.35639 11.7359C9.28173 11.6973 9.18134 11.7359 9.135 11.8286C9.08867 11.9187 9.11441 12.0242 9.18906 12.0654ZM9.18906 15.2987L15.0352 18.3826C15.1124 18.4213 15.2102 18.3826 15.2566 18.29C15.3029 18.1999 15.2772 18.0943 15.2025 18.0531L9.35639 14.9692C9.28173 14.928 9.18134 14.9692 9.135 15.0619C9.08867 15.152 9.11441 15.2575 9.18906 15.2987ZM9.18906 8.83218C9.11184 8.79099 9.08867 8.68545 9.135 8.59535C9.18134 8.50525 9.27916 8.46407 9.35639 8.50268L15.2025 11.5866C15.2797 11.6278 15.3029 11.7334 15.2566 11.8235C15.2102 11.9136 15.1124 11.9547 15.0352 11.9161L9.18906 8.83218ZM6.1669 5.89239V17.6747C6.1669 18.5654 6.7358 19.5977 7.62392 20.0636L14.1805 23.5002L5.46927 20.8256C4.95185 20.666 4.61462 19.922 4.61462 19.366V5.8512C4.61462 5.28744 5.18611 5.16903 5.57997 5.25398C5.96096 5.33635 6.16432 5.60922 6.16432 5.89497L6.1669 5.89239ZM26.7326 3.59359L18.876 7.71238C18.4049 7.95951 18.0213 8.61595 18.0213 9.17198V22.6868C18.0213 23.2428 18.4049 23.4977 18.876 23.2531L26.7326 19.1343C27.2036 18.8872 27.5872 18.2308 27.5872 17.6747V4.15992C27.5872 3.60131 27.2036 3.34903 26.7326 3.59359ZM25.811 12.0654L19.9649 15.1494C19.8876 15.188 19.7898 15.1494 19.7435 15.0567C19.6971 14.9666 19.7229 14.8611 19.7975 14.8199L25.6437 11.7359C25.7183 11.6973 25.8187 11.7359 25.865 11.8286C25.9114 11.9187 25.8856 12.0242 25.811 12.0654ZM25.811 15.2987L19.9649 18.3826C19.8876 18.4213 19.7898 18.3826 19.7435 18.29C19.6971 18.1999 19.7229 18.0943 19.7975 18.0531L25.6437 14.9692C25.7183 14.928 25.8187 14.9692 25.865 15.0619C25.9114 15.152 25.8856 15.2575 25.811 15.2987ZM25.811 8.83218C25.8882 8.79099 25.9114 8.68545 25.865 8.59535C25.8187 8.50525 25.7209 8.46407 25.6437 8.50268L19.7975 11.5866C19.7203 11.6278 19.6971 11.7334 19.7435 11.8235C19.7898 11.9136 19.8876 11.9547 19.9649 11.9161L25.811 8.83218ZM28.8331 5.89239V17.6747C28.8331 18.5654 28.2642 19.5977 27.3761 20.0636L20.8195 23.5002L29.5308 20.8256C30.0482 20.666 30.3854 19.922 30.3854 19.366V5.8512C30.3854 5.28744 29.8139 5.16903 29.4201 5.25398C29.0391 5.33635 28.8357 5.60922 28.8357 5.89497L28.8331 5.89239Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_892_122"
            x="0.614624"
            y="0.500244"
            width="33.7708"
            height="28"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.211765 0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_892_122"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_892_122"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    )
  },
  {
    title: "menu",
    link: "#menu",
    svg: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="31"
        height="28"
        viewBox="0 0 31 28"
        fill="none"
      >
        <g filter="url(#filter0_d_892_207)">
          <path
            d="M4 5.30793C4 4.03343 4.95053 3.00024 6.12308 3.00024H24.8769C26.0495 3.00024 27 4.03343 27 5.30793C27 6.58243 26.0495 7.61562 24.8769 7.61562H6.12308C4.95053 7.61562 4 6.58243 4 5.30793Z"
            fill="white"
          />
          <path
            d="M4 13.0002C4 11.7257 4.95053 10.6925 6.12308 10.6925H24.8769C26.0495 10.6925 27 11.7257 27 13.0002C27 14.2747 26.0495 15.3079 24.8769 15.3079H6.12308C4.95053 15.3079 4 14.2747 4 13.0002Z"
            fill="white"
          />
          <path
            d="M4 20.6926C4 19.4181 4.95053 18.3849 6.12308 18.3849H24.8769C26.0495 18.3849 27 19.4181 27 20.6926C27 21.9671 26.0495 23.0002 24.8769 23.0002H6.12308C4.95053 23.0002 4 21.9671 4 20.6926Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_d_892_207"
            x="0"
            y="0.000244141"
            width="31"
            height="28"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feGaussianBlur stdDeviation="2" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.211765 0 0 0 0 0.0470588 0 0 0 0 0.0470588 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_892_207"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_892_207"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    ),
  },
];
